import isPlainObject from 'lodash/isPlainObject'
import isArray from 'lodash/isArray'
import camelCase from 'lodash/camelCase'
import snakeCase from 'lodash/snakeCase'

class Transform {
  /**
   * Translate numbers to local mode
   * @param {Number} val value to parse
   * @param {any} params additional params
   */
  toLocaleString(val = '', ...params) {
    return val.toLocaleString('fa-IR', ...params)
  }

  /**
   *
   * @param {Array} array
   * @return {Array}
   */
  array(array) {
    return array.map(item => this.any(item))
  }

  /**
   *
   * @param {Object} object
   * @return {Object}
   */
  object(object) {
    let _result = {}

    for (let key in object) {
      _result[key] = this.any(object[key])
    }

    return _result
  }

  /**
   *
   * @param {*} value
   * @return {*}
   */
  any(value) {
    if (isPlainObject(value)) {
      value = this.object(value)
    } else if (isArray(value)) {
      value = this.array(value)
    }

    return value
  }

  /**
   * camel case objects
   * @param {Object} object the object you want to make it camel cased
   * @return {Object} camel cased object
   */
  objectToCamel(object) {
    let _result = {}

    for (let key in object) {
      _result[camelCase(key)] = this.snakeToCamel(object[key])
    }

    return _result
  }

  /**
   *
   * @param {Array} array
   * @return {Array}
   */
  arrayToCamel(array) {
    let _array = []

    array.map(value => _array.push(this.snakeToCamel(value)))

    return _array
  }

  /**
   *
   * @param {String|Object|Array} value
   * @return {*}
   */
  snakeToCamel(value) {
    if (isPlainObject(value)) {
      value = this.objectToCamel(value)
    } else if (isArray(value)) {
      value = this.arrayToCamel(value)
    }

    return value
  }

  /**
   *
   * @param {Object} object
   * @return {Object}
   */
  objectToSnake(object) {
    let result = {}

    for (let key in object) {
      result[snakeCase(key)] = this.camelToSnake(object[key])
    }

    return result
  }

  /**
   *
   * @param {Array} array
   * @return {Array}
   */
  arrayToSnake(array) {
    let _array = []

    array.map(value => _array.push(this.camelToSnake(value)))

    return _array
  }

  /**
   *
   * @param {String|Object|Array} value
   * @return {*}
   */
  camelToSnake(value) {
    if (isPlainObject(value)) {
      value = this.objectToSnake(value)
    } else if (isArray(value)) {
      value = this.arrayToSnake(value)
    }

    return value
  }

  /**
   * get number and separator
   * @param {number} num number for separator
   * @param {string} sep separator
   */
  separator(num, sep = ',') {
    if (num !== undefined) {
      var number = typeof num === "number" ? num.toString() : num
      return number.replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + sep);
    } else {
      return num
    }
  }
}

export default new Transform()
